module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAlCAYAAAB7yHheAAAACXBIWXMAAA9hAAAPYQGoP6dpAAABIUlEQVQ4jY3TWytEURiH8d8Yp1IO5cINLlxQwkQkh3wSn3WIyCVXcsg5lAuJCBkXa4/GNvNu79Vu7Wc9633X3n9Yx6CCasMVlv8D7mECfRFYxid6MIqTyAi7mMk2tDTCO/oxhLPICDuYQ3dkhNfM2IfLyAjbWERHZIQXafou3ETGunUp/y5vhCeMZ893kbFuXUapCDzFh/RpQxC2sPof8FC6pjGaD9NYH1jAfmSEAwxguMhYwxcqRUZ4Rm8RWMIaNorASSkBRxH4Y0MtAqfwhmNaX3hbg00ETkvTnkZgObNV80fkq4JHnEdgWfpjqrn1P+AsHhSksD2zbTRp5xc4J2XkOgI7sNKstzw4L+X4NgI7pRy3tNXBBVzgvggcwWYEwTcZjjX2X6gUpAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/arrow.png
// module id = c+zA
// module chunks = 0